import { PrinterAndCheckNoResponseType } from 'pages/VendorsTablePage/components/PrintChecks/CheckSequence/types';

export const printerAndCheckNoData: PrinterAndCheckNoResponseType[] = [
  {
    nextCheckNo: '361',
    dmsPrinterNo: '1',
    cloudPrinterId: 'bc622279-6974-4a36-a9c4-2892226d0d5d',
    printerId: '3a803b35-9cae-40a4-9e18-18b4bcefea56',
    isDefaultPrinter: true,
    isAccountingPrinter: false,
    printerDetails: {
      printerName: 'TOYLSRBOP',
      checkTray: 'Tray2',
      overFlowTray: 'Tray2',
      isMICRPrinter: false
    }
  },
  {
    nextCheckNo: '361',
    dmsPrinterNo: '1',
    cloudPrinterId: 'bc622279-6974-4a36-a9c4-2892226d0d5d',
    printerId: '3a803b35-9cae-40a4-9e18-18b4bcefea56',
    isDefaultPrinter: true,
    isAccountingPrinter: false,
    printerDetails: {
      printerName: 'TOYLSRBOP',
      checkTray: 'Tray3',
      overFlowTray: 'Tray3',
      isMICRPrinter: false
    }
  },
  {
    nextCheckNo: 'null',
    dmsPrinterNo: 'null',
    cloudPrinterId: '4c3d2623-1aec-46dc-b8ca-6d1fb7a3e8dc',
    printerId: 'null',
    isDefaultPrinter: false,
    isAccountingPrinter: true,
    printerDetails: {
      printerName: 'Virtual_Printer',
      checkTray: 'Tray4',
      overFlowTray: 'Tray4',
      isMICRPrinter: false
    }
  }
];

export const printerAndCheckData: PrinterAndCheckNoResponseType[] = [
  {
    nextCheckNo: '102',
    dmsPrinterNo: 'A1235',
    cloudPrinterId: '1133',
    printerId: 'A10',
    isDefaultPrinter: true,
    isAccountingPrinter: false,
    printerDetails: {
      printerName: 'Test Printer',
      checkTray: 'Tray 99',
      overFlowTray: 'Tray 100',
      isMICRPrinter: false
    }
  },
  {
    nextCheckNo: '101',
    dmsPrinterNo: 'A1234',
    cloudPrinterId: '1122',
    printerId: 'A09',
    isDefaultPrinter: false,
    isAccountingPrinter: true,
    printerDetails: {
      printerName: 'Test Printer 2',
      checkTray: 'Tray 10',
      overFlowTray: 'Tray 101',
      isMICRPrinter: false
    }
  },
  {
    nextCheckNo: '101',
    dmsPrinterNo: 'A1234',
    cloudPrinterId: '1122',
    printerId: 'A09',
    isDefaultPrinter: false,
    isAccountingPrinter: true,
    printerDetails: {
      printerName: 'Test Printer 3',
      checkTray: 'Tray 11',
      overFlowTray: 'Tray 102',
      isMICRPrinter: false
    }
  },
  {
    nextCheckNo: '101',
    dmsPrinterNo: 'A1234',
    cloudPrinterId: '1122',
    printerId: 'A09',
    isDefaultPrinter: false,
    isAccountingPrinter: true,
    printerDetails: {
      printerName: 'Test Printer 4',
      checkTray: 'Tray 12',
      overFlowTray: 'Tray 103',
      isMICRPrinter: false
    }
  }
];
